//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React from 'react';
import styled from 'styled-components';
import { LOGO } from 'utils/assets/images';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
export const Wrapper = styled.img`
    height: 100px;
    width: auto;

    @media (max-width: 992px) {
        height: 85px !important;
    }
`;


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Logo
//
//  -- Description
//  Experimental app logo
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const Logo = ({ height, width }) => (<>
<Wrapper src={LOGO} style={{ height: height, width: width }}></Wrapper>
</>

);

export default Logo;